import Vue from 'vue'

Vue.mixin({
  methods: {
    addQuery (query) {
      return {
        query: {
          ...this.$route.query,
          ...query
        }
      }
    }
  }
})
